import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import ModalComponent from "../ModalComponent";
import ValidationErrors from "../forms/ValidationErrors";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";

const ManageRateCardModal = ({ rateCard, onSubmit }) => {
  const initialValues = rateCard ? rateCard : {}
  const title = rateCard ? 'Edit Rate Card' : 'Create Rate Card'
  const isNew = !rateCard
  const deprecated = rateCard ? rateCard.deprecated : false

  return (
    <Formik
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={(values, { setErrors }) => onSubmit(values, { setErrors })}
    >
      {({
        values,
        errors,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => {
        const buttons = [
          <Button
            variant="primary"
            type="submit"
            disabled={isSubmitting}
            onClick={handleSubmit}
          >
            {isSubmitting ? 'Submitting' : 'Submit'}
          </Button>
        ]

        const handleNameChange = event => {
          const { _, value } = event.target
          handleChange(event)

          if (isNew) {
            const newCanonicalName = value.toLowerCase().replace(/\s+/g, '_')
            setFieldValue('canonical_name', newCanonicalName)
          }
        }

        return (
          <ModalComponent className="manage-rate-card-modal" title={title} buttons={buttons}>
            <form>
              <div className="form-horizontal">
                <ValidationErrors errors={errors} fieldNames={{}} />

                <div className={classNames('mb-3 row', errors.name ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">Display Name</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='name'
                      type='text'
                      value={values.name}
                      onChange={handleNameChange}
                      disabled={deprecated} // only disabling the name change if it was previously deprecated.  Admin can change before they retire the rate card.
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.canonical_name ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">Canonical Name</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='canonical_name'
                      type='text'
                      value={values.canonical_name}
                      disabled
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.domestic_cc_percent ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">Domestic CC Percentage</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='domestic_cc_percent'
                      type='text'
                      value={values.domestic_cc_percent}
                      onChange={handleChange}
                      disabled={!isNew}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.intl_cc_percent ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">International CC Percentage</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='intl_cc_percent'
                      type='text'
                      value={values.intl_cc_percent}
                      onChange={handleChange}
                      disabled={!isNew}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.ach_rate ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">ACH Rate Fee</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='ach_rate'
                      type='text'
                      value={values.ach_rate}
                      onChange={handleChange}
                      disabled={!isNew}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.nsf_rate ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">NSF Rate Fee</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='nsf_rate'
                      type='text'
                      value={values.nsf_rate}
                      onChange={handleChange}
                      disabled={!isNew}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.chargeback_rate ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">Chargeback Rate Fee</Form.Label>
                  <div className="controls">
                    <Form.Control
                      name='chargeback_rate'
                      type='text'
                      value={values.chargeback_rate}
                      onChange={handleChange}
                      disabled={!isNew}
                    />
                  </div>
                </div>

                <div className={classNames('mb-3 row', errors.deprecated ? 'has-error' : null)}>
                  <Form.Label htmlFor="name">Deprecated</Form.Label>
                  <div className="controls">
                    <Form.Check
                      name='deprecated'
                      type='checkbox'
                      disabled={isNew}
                      defaultChecked={!!values.deprecated}
                      onChange={handleChange}
                    />
                  </div>
                </div>

              </div>
            </form>
          </ModalComponent>
        )
      }}
    </Formik>
  )
}

ManageRateCardModal.propTypes = {
  rateCard: PropTypes.object,
  onSubmit: PropTypes.func,
}

ManageRateCardModal.defaultProps = {
  rateCard: null,
  onSubmit: () => false,
}

export default ManageRateCardModal
